/**
 * Where the site talks to. Set PUBLIC_API_URL / PUBLIC_APP_URL in the environment (or .env);
 * bunfig.toml's `[serve.static] env = "PUBLIC_*"` inlines them into the browser bundle (build.ts does the same).
 * When they aren't inlined `process` doesn't exist in the browser, hence the try.
 */
function read(get: () => string | undefined, fallback: string) {
  try {
    const v = get();
    return v ? v.replace(/\/+$/, "") : fallback;
  } catch {
    return fallback;
  }
}

/** The lesson server (backend/). */
export const API_URL = read(() => process.env.PUBLIC_API_URL, "http://localhost:8787");

/** The web app the hero hands off to (later app.learnanything.now). */
export const APP_URL = read(() => process.env.PUBLIC_APP_URL, "http://localhost:8091");

/** The app's lesson screen for a session the hero already ran the intake for. */
export const reelUrl = (session: string) => `${APP_URL}/reel?session=${encodeURIComponent(session)}&answered=1`;

/** Store listings. The apps aren't published yet, so these default to "#" (badges show "Coming soon"). */
export const APP_STORE_URL = read(() => process.env.PUBLIC_APP_STORE_URL, "#");
export const PLAY_STORE_URL = read(() => process.env.PUBLIC_PLAY_STORE_URL, "#");
